module.exports = __webpack_public_path__ + "static/media/13.2ec03c46.jpeg";